export const MilestoneLogsConstants= {
 
    GET_MilestoneLogs_REQUEST: 'GET_MilestoneLogs_REQUEST',
    GET_MilestoneLogs_SUCCESS: 'GET_MilestoneLogs_SUCCESS',
    GET_MilestoneLogs_FAILURE: 'GET_MilestoneLogs_FAILURE',
}